package com.hyperether.goodjob.scenes.addNew

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.wrapContentWidth
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.DisableSelection
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.Button
import androidx.compose.material.ButtonDefaults
import androidx.compose.material.Divider
import androidx.compose.material.Icon
import androidx.compose.material.Text
import androidx.compose.material3.OutlinedButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.platform.LocalFocusManager
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.navigation.NavHostController
import com.hyperether.goodjob.models.Role
import com.hyperether.goodjob.models.UserStatus
import com.hyperether.goodjob.navigation.SettingsWeb
import com.hyperether.goodjob.navigation.UserDetails
import com.hyperether.goodjob.navigation.Users
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.active
import com.hyperether.goodjob.resources.add_new_employee
import com.hyperether.goodjob.resources.address
import com.hyperether.goodjob.resources.admin
import com.hyperether.goodjob.resources.briefcase_unselect
import com.hyperether.goodjob.resources.building
import com.hyperether.goodjob.resources.calendar__1_
import com.hyperether.goodjob.resources.cancel
import com.hyperether.goodjob.resources.city
import com.hyperether.goodjob.resources.country
import com.hyperether.goodjob.resources.date_error
import com.hyperether.goodjob.resources.email_address_mandatory
import com.hyperether.goodjob.resources.employee
import com.hyperether.goodjob.resources.employee_added_successfully
import com.hyperether.goodjob.resources.employee_details
import com.hyperether.goodjob.resources.employee_updated_successfully
import com.hyperether.goodjob.resources.enter_city
import com.hyperether.goodjob.resources.enter_country
import com.hyperether.goodjob.resources.enter_full_name
import com.hyperether.goodjob.resources.enter_your_email
import com.hyperether.goodjob.resources.enter_zip_code
import com.hyperether.goodjob.resources.error
import com.hyperether.goodjob.resources.full_name
import com.hyperether.goodjob.resources.ic_leave
import com.hyperether.goodjob.resources.ic_mail
import com.hyperether.goodjob.resources.ic_user
import com.hyperether.goodjob.resources.ic_work_scheduler
import com.hyperether.goodjob.resources.inactive
import com.hyperether.goodjob.resources.mail
import com.hyperether.goodjob.resources.manager
import com.hyperether.goodjob.resources.ok
import com.hyperether.goodjob.resources.phone
import com.hyperether.goodjob.resources.phone_24
import com.hyperether.goodjob.resources.role_mandatory
import com.hyperether.goodjob.resources.save_changes
import com.hyperether.goodjob.resources.select_role
import com.hyperether.goodjob.resources.set_weekly_hours
import com.hyperether.goodjob.resources.status
import com.hyperether.goodjob.resources.status_mandatory
import com.hyperether.goodjob.resources.success
import com.hyperether.goodjob.resources.upcoming_leaves
import com.hyperether.goodjob.resources.work_schedule
import com.hyperether.goodjob.resources.world_2_svgrepo_com_1
import com.hyperether.goodjob.resources.zip_employee
import com.hyperether.goodjob.scenes.components.AddCustomInputRow
import com.hyperether.goodjob.scenes.components.AddressInputFieldWeb
import com.hyperether.goodjob.scenes.components.ErrorDialog
import com.hyperether.goodjob.scenes.components.PopUpDialog
import com.hyperether.goodjob.scenes.components.ProfilePictureSection
import com.hyperether.goodjob.scenes.components.SkillSelectorWeb
import com.hyperether.goodjob.scenes.components.TeamSelectorWeb
import com.hyperether.goodjob.scenes.components.WebViewHeader
import com.hyperether.goodjob.scenes.components.clickableWithPointer
import com.hyperether.goodjob.scenes.components.disableMouseDragScrollOnWeb
import com.hyperether.goodjob.scenes.components.verticalScrollbar
import com.hyperether.goodjob.scenes.register.FullScreenProgressBar
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.theme.DashboardBg
import com.hyperether.goodjob.theme.EmployeeDetailsText
import com.hyperether.goodjob.theme.InputBorderColor
import com.hyperether.goodjob.util.Constants.DEFAULT_EMPLOYEE_ID
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.stringResource
import io.wojciechosak.calendar.config.SelectionMode
import kotlinx.coroutines.delay
import kotlinx.datetime.LocalDate
import org.jetbrains.compose.resources.painterResource

@Composable
fun AddNewUserWeb(
    viewModel: AddUserViewModel, navHostController: NavHostController, employeeId: String?
) {

    val teams by viewModel.teams.collectAsState(emptyList())
    val availableTeamNames = teams.map { it.name ?: "" }
    val dropdownTeamsItemsState = remember { mutableStateOf(emptyList<String>()) }

    val selectedSkills by viewModel.selectedSkills.collectAsState(emptyList())
    val dropdownSkills by viewModel.availableSkills.collectAsState(emptyList())
    val preselectedSkills by viewModel.preselectedSkills.collectAsState(emptyList())

    val selectedSkillNamesState = remember { mutableStateOf(selectedSkills) }
    val preselectedSkillNamesState = remember { mutableStateOf(preselectedSkills) }
    val dropdownSkillNamesState = remember { mutableStateOf(dropdownSkills.map { it.name ?: "" }) }

    val isEmployee = viewModel.isEmployee()

    if (viewModel.isAdmin()) {
        viewModel.roleMap = mapOf(
            stringResource(Res.string.admin) to Role.admin.name,
            stringResource(Res.string.manager) to Role.manager.name,
            stringResource(Res.string.employee) to Role.employee.name,
        )
    } else if (viewModel.isManager()) {
        viewModel.roleMap = mapOf(
            stringResource(Res.string.manager) to Role.manager.name,
            stringResource(Res.string.employee) to Role.employee.name
        )
    } else {
        viewModel.roleMap = mapOf(
            stringResource(Res.string.employee) to Role.employee.name
        )
    }
    if (viewModel.isManager() || viewModel.isAdmin()) {
        viewModel.userStatusMap = mapOf(
            stringResource(Res.string.active) to UserStatus.active.name,
            stringResource(Res.string.inactive) to UserStatus.inactive.name
        )
    } else {
        viewModel.userStatusMap = mapOf(
            stringResource(Res.string.active) to UserStatus.active.name,
        )
    }

    val roles = viewModel.roleMap.map { it.key }

    val statuses = listOf(
        stringResource(Res.string.active), stringResource(Res.string.inactive)
    )

    val focusManager = LocalFocusManager.current
    val focusRequester = FocusRequester()
    val showWorkingHoursView = remember { mutableStateOf(false) }

    val id = if (employeeId?.contains("profileSettings") == true) {
        employeeId.substringAfter("-")
    } else {
        employeeId
    }

    LaunchedEffect(availableTeamNames, teams) {
        dropdownTeamsItemsState.value = availableTeamNames
    }

    LaunchedEffect(selectedSkills) {
        selectedSkillNamesState.value = selectedSkills
    }

    LaunchedEffect(preselectedSkills) {
        preselectedSkillNamesState.value = preselectedSkills
    }

    LaunchedEffect(dropdownSkills) {
        dropdownSkillNamesState.value = dropdownSkills.map { it.name ?: "" }
    }

    val employee by viewModel.selectedUser.collectAsState()

    LaunchedEffect(id) {
        when (id) {
            null -> viewModel.clearUserValues()
            DEFAULT_EMPLOYEE_ID -> viewModel.clearUserValues()
            "" -> viewModel.clearUserValues()
            else -> employeeId?.let { viewModel.getUserById(it) }
        }
    }

    println("EMPLOYEE_ID" + employeeId)

    LaunchedEffect(employee) {
        delay(500)
        if (!employeeId.isNullOrEmpty() && employeeId != DEFAULT_EMPLOYEE_ID) {
            println("EMPLOYEE" + employee.toString())
            employee.let {
                viewModel.roleSelected.value =
                    viewModel.roleMap.entries.find { role -> role.value == it?.role }?.key
                        ?: viewModel.roleSelected.value

                viewModel.fullNameInput.value = it?.fullName ?: viewModel.fullNameInput.value
                viewModel.phoneInput.value = it?.phone ?: viewModel.phoneInput.value
                viewModel.emailInput.value = it?.email ?: viewModel.emailInput.value
                viewModel.cityInput.value = it?.city ?: viewModel.cityInput.value
                viewModel.countryInput.value = it?.country ?: viewModel.countryInput.value
                viewModel.addressInput.value = it?.address ?: viewModel.addressInput.value
                viewModel.zipInput.value = it?.zip ?: viewModel.zipInput.value
                viewModel.status.value = it?.status ?: viewModel.status.value
                println("STATUS" + viewModel.status.value)
                viewModel.status.value =
                    viewModel.userStatusMap.entries.find { entry -> entry.value == it?.status }?.key
                        ?: viewModel.status.value
                viewModel.upcomingLeaves.value =
                    it?.upcomingLeave ?: viewModel.upcomingLeaves.value
                viewModel.teamInput.value = it?.teams
                    ?.mapNotNull { userTeam -> teams.find { team -> team.name == userTeam?.value } }
                    ?: viewModel.teamInput.value
                viewModel.setPreselectedSkills(
                    it?.skills ?: viewModel.preselectedSkills.value
                )
                viewModel.setSelectedSkills(it?.skills ?: viewModel.selectedSkills.value)

                val workingHours = it?.workingHours
                workingHours?.let { hours ->
                    viewModel.daysSchedule.forEach { daySchedule ->
                        val dayHours = when (daySchedule.dayInt) {
                            0 -> hours.monday
                            1 -> hours.tuesday
                            2 -> hours.wednesday
                            3 -> hours.thursday
                            4 -> hours.friday
                            5 -> hours.saturday
                            6 -> hours.sunday
                            else -> null
                        }

                        // Update daySchedule properties
                        dayHours?.let { dh ->
                            daySchedule.isChecked.value = dh.enabled ?: false
                            daySchedule.startTime.value = dh.from ?: "08:00"
                            daySchedule.endTime.value = dh.to ?: "16:00"
                        } ?: run {
                            daySchedule.isChecked.value = false
                        }
                    }
                }
            }
        } else {
            viewModel.clearUserValues()
        }
    }

    val outerScrollState = rememberScrollState()
    var blockOuterScroll by remember { mutableStateOf(false) }

    Column(
        modifier = Modifier.fillMaxSize().background(DashboardBg)
            .verticalScrollbar(outerScrollState)
            .verticalScroll(
                state = outerScrollState,
                enabled = !blockOuterScroll
            )
            .disableMouseDragScrollOnWeb()
    ) {
        val headerTitle = if (employeeId == DEFAULT_EMPLOYEE_ID || employeeId == "") {
            stringResource(Res.string.add_new_employee)
        } else {
            viewModel.selectedUser.value?.getName() ?: ""
        }
        WebViewHeader(
            isAddNewUser = true,
            isBackAvailable = true,
            onBackClick = {
                employeeId?.let {
                    if (employeeId == DEFAULT_EMPLOYEE_ID || employeeId == "") {
                        navHostController.navigate(Users)
                    } else if (employeeId.contains("profileSettings")) {
                        navHostController.navigate(SettingsWeb)
                    } else {
                        navHostController.navigate(UserDetails(it))
                    }
                }
            },
            title = headerTitle,
            isImportAndAddVisible = false,
            navHostController = navHostController
        )

        AddNewHeader(
            titleText = stringResource(Res.string.employee_details),
            showDelete = false,
            deleteText = "",
            onDelete = {}
        ) {
            // Form inputs
            Column(
                modifier = Modifier.weight(4f),
                verticalArrangement = Arrangement.spacedBy(10.toScaleDp())
            ) {
                LaunchedEffect(true) {
                    focusRequester.requestFocus()
                }
                DisableSelection {
                    CustomDropdownMenu(
                        iconRes = null,
                        labelText = stringResource(Res.string.status_mandatory),
                        placeholderText = stringResource(Res.string.status),
                        items = statuses,
                        selectedValue = viewModel.status.value,
                        onValueSelected = { viewModel.status.value = it },
                        focusManager = focusManager,
                        modifier = Modifier
                    )
                }
                DisableSelection {
                    CustomDropdownMenu(
                        iconRes = Res.drawable.briefcase_unselect,
                        labelText = stringResource(Res.string.role_mandatory),
                        placeholderText = stringResource(Res.string.select_role),
                        items = roles,
                        selectedValue = viewModel.roleSelected.value,
                        onValueSelected = { viewModel.roleSelected.value = it },
                        focusManager = focusManager,
                        modifier = Modifier
                    )
                }
                AddCustomInputRow(
                    painterResource = Res.drawable.ic_user,
                    labelText = stringResource(Res.string.full_name),
                    placeholderText = stringResource(Res.string.enter_full_name),
                    inputValue = viewModel.fullNameInput.value,
                    onValueChange = {
                        viewModel.fullNameInput.value = ""
                        viewModel.fullNameInput.value = it
                    },
                    focusManager = focusManager,
                    modifier = Modifier
                )
                AddCustomInputRow(
                    painterResource = Res.drawable.ic_mail,
                    labelText = stringResource(Res.string.email_address_mandatory),
                    placeholderText = stringResource(Res.string.enter_your_email),
                    inputValue = viewModel.emailInput.value,
                    onValueChange = {
                        viewModel.emailInput.value = ""
                        viewModel.emailInput.value = it
                    },
                    enabled = employeeId == DEFAULT_EMPLOYEE_ID || employeeId.isNullOrEmpty(),
                    focusManager = focusManager,
                    modifier = Modifier
                )
                CustomNumberInputRowUser(
                    painterResource = Res.drawable.phone_24,
                    labelText = stringResource(Res.string.phone),
                    placeholderText = "+1 555 123 4567",
                    inputValue = viewModel.phoneInput.value,
                    onValueChange = {
                        viewModel.phoneInput.value = ""
                        viewModel.phoneInput.value = it
                    },
                    focusManager = focusManager,
                    modifier = Modifier
                )
                AddressInputFieldWeb(
                    textCountry = viewModel.countryInput,
                    textCity = viewModel.cityInput,
                    text = viewModel.addressInput,
                    label = stringResource(Res.string.address),
                    onSearch = { viewModel.findPlace(it) },
                    onSelect = {
                        viewModel.addressInput.value = it.street ?: it.formattedAddress
                        viewModel.zipInput.value = it.zip ?: viewModel.zipInput.value
                        viewModel.cityInput.value = it.city ?: viewModel.cityInput.value
                        viewModel.countryInput.value =
                            it.country ?: viewModel.countryInput.value
                        viewModel.place = it
                    },
                    places = viewModel.places,
                    focusManager = focusManager,
                    modifier = Modifier
                )
                AddCustomInputRow(
                    painterResource = Res.drawable.building,
                    labelText = stringResource(Res.string.city),
                    placeholderText = stringResource(Res.string.enter_city),
                    inputValue = viewModel.cityInput.value,
                    onValueChange = {
                        viewModel.cityInput.value = ""
                        viewModel.cityInput.value = it
                    },
                    focusManager = focusManager,
                    modifier = Modifier
                )
                AddCustomInputRow(
                    painterResource = Res.drawable.world_2_svgrepo_com_1,
                    labelText = stringResource(Res.string.country),
                    placeholderText = stringResource(Res.string.enter_country),
                    inputValue = viewModel.countryInput.value,
                    onValueChange = {
                        viewModel.countryInput.value = ""
                        viewModel.countryInput.value = it
                    },
                    focusManager = focusManager,
                    modifier = Modifier
                )
                AddCustomInputRow(
                    painterResource = Res.drawable.mail,
                    labelText = stringResource(Res.string.zip_employee),
                    placeholderText = stringResource(Res.string.enter_zip_code),
                    inputValue = viewModel.zipInput.value,
                    onValueChange = { newValue ->
                        if (newValue.all { it.isDigit() } && newValue.length <= 12) {
                            viewModel.zipInput.value = ""
                            viewModel.zipInput.value = newValue
                        }
                    },
                    focusManager = focusManager,
                    modifier = Modifier
                )
                Divider(
                    modifier = Modifier
                        .height(1.toScaleDp())
                        .background(Color.LightGray.copy(alpha = 0.1f))
                )

                SkillSelectorWeb(
                    selectedSkills = selectedSkillNamesState,
                    onSkillsSelected = { newSelectedItems ->
                        selectedSkillNamesState.value = newSelectedItems
                        viewModel.setSelectedSkills(newSelectedItems)
                    },
                    availableSkills = dropdownSkillNamesState,
                    preselectedSkills = preselectedSkillNamesState,
                    onAddNewSkill = { name -> viewModel.addNewSkill(name) },
                    onScrollStart = { blockOuterScroll = true },
                    onScrollEnd = { blockOuterScroll = false }
                )

                TeamSelectorWeb(
                    teamsFromDb = teams,
                    selectedTeams = viewModel.teamInput,
                    onTeamsSelected = { newTeams ->
                        viewModel.teamInput.value = newTeams
                    },
                    onAddNewTeam = { name ->
                        viewModel.createTeam(name) { newTeam ->
                            newTeam?.let {
                                viewModel.teamInput.value = viewModel.teamInput.value + it
                            }
                        }
                    },
                    isEmployee = isEmployee
                )

                Row(
                    modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        modifier = Modifier.weight(1f)
                    ) {
                        Image(
                            modifier = Modifier.size(20.toScaleDp()),
                            painter = painterResource(Res.drawable.ic_work_scheduler),
                            contentDescription = null,
                        )
                        Text(
                            text = stringResource(Res.string.work_schedule),
                            color = EmployeeDetailsText,
                            fontSize = 14.toScaleSp(),
                            modifier = Modifier.padding(start = 20.toScaleDp()),
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                    }

                    Row(
                        modifier = Modifier
                            .weight(2f)
                            .padding(end = 16.toScaleDp())
                            .pointerHoverIcon(PointerIcon.Hand),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Text(
                            text = stringResource(Res.string.set_weekly_hours),
                            color = BlueApp,
                            fontSize = 14.toScaleSp(),
                            fontWeight = FontWeight.Bold,
                            modifier = Modifier.fillMaxWidth().clickableWithPointer {
                                showWorkingHoursView.value = true
                            },
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                    }
                }
                if (showWorkingHoursView.value) {
                    Box(
                        modifier = Modifier.fillMaxWidth().height(400.toScaleDp())
                    ) {
                        WorkingHoursView(viewModel)
                    }
                }

                Row(
                    modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        modifier = Modifier.weight(1f)
                    ) {
                        Image(
                            modifier = Modifier.size(20.toScaleDp()),
                            painter = painterResource(Res.drawable.ic_leave),
                            contentDescription = null
                        )
                        Text(
                            text = stringResource(Res.string.upcoming_leaves),
                            color = EmployeeDetailsText,
                            fontSize = 14.toScaleSp(),
                            modifier = Modifier.padding(start = 20.toScaleDp()),
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                    }

                    OutlinedButton(
                        onClick = { viewModel.isCalendar2Visible.value = true },
                        border = BorderStroke(1.toScaleDp(), InputBorderColor),
                        shape = RoundedCornerShape(8),
                        colors = androidx.compose.material3.ButtonDefaults.outlinedButtonColors(
                            contentColor = Color.White, containerColor = Color.Transparent
                        ),
                        modifier = Modifier.weight(2f).height(50.toScaleDp())
                    ) {
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.SpaceBetween,
                            modifier = Modifier.fillMaxWidth(),
                        ) {
                            Text(
                                text = viewModel.upcomingLeaves.value,
                                color = EmployeeDetailsText,
                                fontSize = 14.toScaleSp(),
                                textAlign = TextAlign.Start,
                                modifier = Modifier.weight(5f)
                            )
                            Icon(
                                painter = painterResource(Res.drawable.calendar__1_),
                                contentDescription = "",
                                modifier = Modifier.size(20.toScaleDp())
                            )
                        }
                    }
                }
                Spacer(modifier = Modifier.height(15f.toScaleDp()))
                Box(
                    modifier = Modifier.fillMaxWidth()
                ) {
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.spacedBy(16.toScaleDp()) // Space between buttons
                    ) {
                        Button(
                            onClick = {
                                viewModel.showLoader.value = true
                                if (employeeId == DEFAULT_EMPLOYEE_ID || employeeId == "") {
                                    viewModel.addUser(onSuccess = {
                                        viewModel.showLoader.value = false
                                        viewModel.showPopUpSuccess.value = true
                                    }, onError = {
                                        viewModel.showLoader.value = false
                                        viewModel.showPopUpError.value = true
                                    })
                                } else {
                                    viewModel.updateUser(onSuccess = {
                                        viewModel.showLoader.value = false
                                        viewModel.showPopUpSuccess.value = true
                                    }, onError = {
                                        viewModel.showLoader.value = false
                                        viewModel.showPopUpError.value = true
                                    })
                                }
                            },
                            modifier = Modifier
                                .weight(1f)
                                .height(56.toScaleDp())
                                .pointerHoverIcon(PointerIcon.Hand),
                            shape = RoundedCornerShape(56.toScaleDp()),
                            colors = ButtonDefaults.buttonColors(BlueApp),
                        ) {
                            DisableSelection {
                                Text(
                                    modifier = Modifier.padding(vertical = 8.toScaleDp()),
                                    text = if (employeeId == DEFAULT_EMPLOYEE_ID || employeeId == "")
                                        stringResource(Res.string.add_new_employee)
                                    else stringResource(Res.string.save_changes),
                                    color = Color.White,
                                    maxLines = 1,
                                    fontSize = 14.toScaleSp(),
                                    overflow = TextOverflow.Ellipsis
                                )
                            }
                        }
                        androidx.compose.material.OutlinedButton(
                            onClick = { navHostController.popBackStack() },
                            border = BorderStroke(1.toScaleDp(), EmployeeDetailsText),
                            modifier = Modifier
                                .weight(1f)
                                .height(56.toScaleDp())
                                .pointerHoverIcon(PointerIcon.Hand),
                            shape = RoundedCornerShape(25.toScaleDp()),
                            colors = ButtonDefaults.outlinedButtonColors(
                                backgroundColor = Color.White,
                                contentColor = Color.Black
                            ),
                        ) {
                            DisableSelection {
                                Text(
                                    modifier = Modifier.padding(vertical = 8.toScaleDp()),
                                    text = stringResource(Res.string.cancel),
                                    color = Color.Black,
                                    fontSize = 14.toScaleSp(),
                                    maxLines = 1,
                                    overflow = TextOverflow.Ellipsis
                                )
                            }
                        }
                    }
                }

                if (viewModel.isCalendar2Visible.value) {
                    Spacer(modifier = Modifier.height(20f.toScaleDp()))
                    val error = stringResource(Res.string.date_error)
                    DisableSelection {
                        CustomCalendarView(
                            isMultiDay = true,
                            selectionMode = SelectionMode.Range,
                            onDismiss = { viewModel.isCalendar2Visible.value = false },
                            onDateSelect = { selectedDates ->
                                if (selectedDates.isNotEmpty()) {
                                    val sortedDates = selectedDates.sorted()
                                    val start = sortedDates.first()
                                    val end = sortedDates.last()

                                    fun formatDate(date: LocalDate): String {
                                        val monthAbbreviation =
                                            date.month.name.lowercase().take(3)
                                                .replaceFirstChar { it.uppercase() }
                                        return "$monthAbbreviation ${date.dayOfMonth}"
                                    }

                                    val formattedRange =
                                        if (start.month == end.month && start.year == end.year) {
                                            "${formatDate(start)} - ${end.dayOfMonth}, ${end.year}"
                                        } else {
                                            "${formatDate(start)} - ${formatDate(end)}, ${end.year}"
                                        }

                                    viewModel.upcomingLeaves.value = formattedRange
                                }
                            },
                            showErrorMessage = {
                                viewModel.showPopUpError.value = true
                                viewModel.errorText.value = error
                            })
                    }
                }
            }
            // Profile picture
            Row(
                modifier = Modifier.weight(1f)
            ) {
                if (employee != null && id != DEFAULT_EMPLOYEE_ID && id != "") {
                    DisableSelection {
                        ProfilePictureSection(
                            name = employee?.getName() ?: "",
                            modifier = Modifier
                                .weight(0.6f)
                                .aspectRatio(1f)
                                .wrapContentWidth(Alignment.End)
                        )
                    }
                } else {
                    Box(
                        modifier = Modifier
                            .weight(1f)
                            .padding(10.toScaleDp()),
                    ) { }
                }
            }
        }
        if (viewModel.showPopUpSuccess.value) {
            DisableSelection {
                PopUpDialog(
                    onDismiss = {
                        viewModel.showPopUpSuccess.value = false
                        navHostController.popBackStack()
                    },
                    title = stringResource(Res.string.success).uppercase(),
                    message = if (employeeId == DEFAULT_EMPLOYEE_ID) stringResource(Res.string.employee_added_successfully) else stringResource(
                        Res.string.employee_updated_successfully
                    ),
                    positiveBtnText = stringResource(Res.string.ok),
                    onPositiveBtnClicked = {
                        viewModel.showPopUpSuccess.value = false
                        navHostController.previousBackStackEntry
                            ?.savedStateHandle
                            ?.set("user_updated", true)
                        navHostController.popBackStack()
                    })
            }
        }
        if (viewModel.showPopUpError.value) {
            DisableSelection {
                ErrorDialog(
                    onDismiss = { viewModel.showPopUpError.value = false },
                    title = stringResource(Res.string.error).uppercase(),
                    message = viewModel.errorText.value
                )
            }
        }
        if (viewModel.showLoader.value) {
            DisableSelection {
                FullScreenProgressBar()
            }
        }

        Spacer(modifier = Modifier.height(20.toScaleDp()))
    }
}